import { render } from "./index.vue?vue&type=template&id=277f8d5f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=277f8d5f&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-277f8d5f"

export default script